import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Badge } from "@ui/badge/Badge";
import { Box, HBox, VBox } from "@ui/box/Box";
import { Error } from "@ui/error/Error";
import { Page } from "@ui/page/Page";
import Spacer from "@ui/spacer/Spacer";
import { Spinner } from "@ui/spinner/Spinner";
import { Typo } from "@ui/text/Typo";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { IAcquirerChannel } from "src/types/types";
import { FormParser } from "../FormParser";
import { Informer } from "@ui/informer/Informer";
import { useTheme } from "styled-components";
import { ITheme } from "@ui/theme/GlobalTheme";

export const MerchantChannelPage = () => {
	useLocale();
	const [terminals] = GD.B_TERMINALS.use();

	//const params = useParams(); // id
	const router = useRouter();
	//const acquirerID = router.currentParams.aid;
	const channelId = parseInt(router.currentParams.chid ?? 0);
	const merchantId = parseInt(router.currentParams.mid ?? 0);

	const [channelResponse, , , busyChannel] = GD.REQ_MERCHANT_CHANNEL.useRequest(null, {
		merchantId: merchantId,
		channelId: channelId,
	});

	// const [acquirerResponse, , , busy] = GD.REQ_ACQUIRER.useRequest(null, {
	// 	acquirerID: parseInt(acquirerID),
	// });
	// const acquirer = acquirerResponse?.data ?? null;

	// const [channelResponse, , , busyChannel] =
	// 	GD.REQ_ACQUIRER_CHANNEL.useRequest(null, {
	// 		acquirerID: parseInt(acquirerID),
	// 		channelId: parseInt(channelID),
	// 	});
	// const channel = channelResponse?.data ?? null;

	//const label = (acquirer?.name ?? "") + ": " + (channel?.title ?? "");
	const label = "";

	return (
		<Page
			label={label ?? undefined}
			// rightSection={<RightSectionClients />}
			sectionRightContent={
				<></>
				// <Button
				// 	disabled={!channel || !acquirer}
				// 	variant="primarySmall"
				// 	onClick={function (): void {
				// 		GD.S_ACQUIRER_EDITOR.invoke({
				// 			acquirerID: acquirer?.id ?? 0,
				// 		});
				// 		GD.S_ACQUIRER_CHANNEL_EDITOR.invoke({
				// 			channel: channel!.id,
				// 			acquirerID: acquirer!.id,
				// 		});
				// 	}}>
				// 	Edit acquirer channel
				// </Button>
			}>
			{channelResponse && channelResponse.data && (
				<HBox gap="20px">
					<VBox>
						<Typo variant="headMedium">{channelResponse.data.title}</Typo>
						<Typo variant="caption">{channelResponse.data.channel_type}</Typo>
					</VBox>
					<Badge label={channelResponse.data.status ?? msg("unknown_b23a6a84")} sx={{ padding: "12px 18px", alignSelf: "baseline", lineHeight: "0px" }} />
					<Typo>{terminals?.data?.find(t => t.id === channelResponse.data.terminal_id)?.name}</Typo>
				</HBox>
			)}

			{busyChannel && <Spinner />}
			<Error error={channelResponse?.error} />
			{
				<VBox gap="20px">
					{/* <Tabs checkFeature={feature => checkFeature(feature as TAvailableFeatures)}>
						<TabItem title="Overview">{channelResponse?.data && <OverviewMerchantChannel channel={channelResponse?.data} />}</TabItem>

						<TabItem title="Payments">
							{channelResponse?.data && <Sessions target_id={channelResponse.data.id} target_type="merchant_channel" />}
						</TabItem>

						{integration}
					</Tabs> */}

					{channelResponse?.data && <OverviewMerchantChannel channel={channelResponse.data} />}

					{channelResponse && channelResponse.data && channelResponse.data.channel_type === "individual" && (
						<>
							<Spacer size="10px"/>
							<Typo variant="headMedium">{msg("intergations")}</Typo>
							<FormParser
								key="integrations"
								onSubmit={(data: any) =>
									GD.REQ_API.request({
										method: "settings/set",
										data: data,
									})
								}
								onRequest={() =>
									GD.REQ_API.request({
										method: "settings/get",
										data: {
											target_id: channelResponse.data.link_id,
											target_type: "merchant_channel",
											type: "integration",
										},
									})
								}
							/>
						</>
					)}
				</VBox>
			}
		</Page>
	);
};

const OverviewMerchantChannel = ({ channel }: { channel: IAcquirerChannel }) => {
	useLocale();
	const [terminals] = GD.B_TERMINALS.use();
	const theme = useTheme() as ITheme;

	return (
		<Box>
			<Spacer size="30px" />
			<Informer
				title={msg("info_170322a3")}
				content={
					<Box
						sx={{
							display: "grid",
							gap: "12px",
							columnGap: "20px",
							gridTemplateColumns: "auto 1fr",
						}}>
						<Typo color={theme.colors.textSecondary}>{msg("name")}</Typo>
						<Typo>{channel.title}</Typo>

						<Typo color={theme.colors.textSecondary}>{msg("status")}</Typo>
						<Typo>{channel.status}</Typo>

						<Typo color={theme.colors.textSecondary}>{msg("terminal")}</Typo>
						<Typo>{terminals?.data?.find(t => t.id === channel.terminal_id)?.name}</Typo>

						{/* <pre>{JSON.stringify(channel, null, 2)}</pre> */}
					</Box>
				}></Informer>
		</Box>
	);
};
